import { ShotVersion } from '../../../types';

export type PendingVideoSubmission = true | string;
export type PendingVideoSubmissions = Record<string, PendingVideoSubmission>;

export const VIDEO_SUBMIT_LOCK_MAX_ATTEMPTS = 5;
export const VIDEO_SUBMIT_LOCK_RETRY_DELAY_MS = 800;

export function markPendingVideoSubmission(
  prev: PendingVideoSubmissions,
  shotId: string,
  value: PendingVideoSubmission
): PendingVideoSubmissions {
  return { ...prev, [shotId]: value };
}

export function clearPendingVideoSubmission(
  prev: PendingVideoSubmissions,
  shotId: string
): PendingVideoSubmissions {
  const next = { ...prev };
  delete next[shotId];
  return next;
}

export function hasSubmittedVersion(versions: ShotVersion[], versionId?: string): boolean {
  if (!versionId) return false;
  return versions.some(version => version.id === versionId);
}

export function delay(ms: number): Promise<void> {
  return new Promise(resolve => window.setTimeout(resolve, ms));
}
